import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';

type param = number | ':id' | '*';

export interface DateInfo {
  value: string;
  label: string;
}

export type GetPossibleDaysResponse = {
  selected_date: DateInfo;
  possible_dates: DateInfo[];
  temp_blackout_dates?: { [key: string]: string[] };
};

export async function getPossibleDays(id: param) {
  const query = new URLSearchParams();
  query.set('order_id', id.toString());
  return send<GetPossibleDaysResponse>({
    path: '/api/get_possible_days/',
    method: 'GET',
    query,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
